export const OrganizationType = {
  SINGLE: 1,
  MULTI: 2,
  CHILD: 3,
};
